import { GetTaskConfigurationSettingsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface TaskConfigurationSettings {
  category: string
}

export const useGetTaskConfigurationSettings = (variables: TaskConfigurationSettings) => {
  const { data, loading } = useQuery(GetTaskConfigurationSettingsDocument, {
    variables,
  })

  const settings = data?.processes.taskConfigurationSettings.at(0) ?? []

  return {
    loading,
    settings,
  }
}
